import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class DownloadTemporarioService {
    private http = inject(HttpClient);

    /**
     * Realiza o download de um arquivo temporário pelo token.
     * Retorna o blob do arquivo para ser salvo localmente.
     */
    download(token: string): Observable<Blob> {
        return this.http.get(
            `${environment.api_url}administrativo/download-temporario/${token}` + environment.xdebug,
            { responseType: 'blob', observe: 'body' }
        );
    }

    /**
     * Realiza o download retornando a response completa (para acessar headers como Content-Disposition).
     */
    downloadComResponse(token: string): Observable<HttpResponse<Blob>> {
        return this.http.get(
            `${environment.api_url}administrativo/download-temporario/${token}` + environment.xdebug,
            { responseType: 'blob', observe: 'response' }
        );
    }

    /**
     * Verifica informações do download temporário (disponibilidade, nome do arquivo, etc).
     */
    getInfo(token: string): Observable<DownloadTemporarioInfo> {
        return this.http.get<DownloadTemporarioInfo>(
            `${environment.api_url}administrativo/download-temporario/${token}/info` + environment.xdebug
        );
    }
}

export interface DownloadTemporarioInfo {
    token: string;
    filename: string;
    mimetype: string;
    tamanho: number;
    criado_em: number;
    expira_em: number;
    disponivel: boolean;
}
